import networkTS from '@/misc/apis/networkTS'
import { AiGatewayAiUseCase } from '@/types/api'

export default {
  async getAccountSettings(accountId: string) {
    return networkTS.aiGatewayServiceGetAccountSettings(accountId)
      .then((response) => {
        return response.data
      })
  },
  async setAccountSettings(accountId: string, enabled: boolean, enabledUseCases: AiGatewayAiUseCase[]) {
    return networkTS.aiGatewayServiceSetAccountSettings(accountId, {
      enabled,
      enabledUseCases
    })
      .then((response) => {
        return response.data
      })
  }
}
